"use strict";
var ko = require("knockout");
var $ = require("jquery");
ko.bindingHandlers["btn"] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var observable = valueAccessor(), $el = $(element);
        observable.subscribe(function (isProcessing) {
            if (isProcessing) {
                $el.attr("disabled", "disabled").addClass("is-loading");
            }
            else {
                $el.removeAttr("disabled").removeClass("is-loading");
            }
        });
    }
};
//# sourceMappingURL=ko.btn.js.map